import { defineComponent, shallowRef, watch, openBlock, createElementBlock, Fragment, renderList, createBlock, resolveDynamicComponent, unref, createCommentVNode } from "vue";
import { useRoute } from "vue-router";
import { getVisibleMenuItems } from "./navigation-helper.js";
const _hoisted_1 = ["dsf_title", "dsf_icon", "data-test"];
const _hoisted_2 = ["dsf_id", "dsf_title", "dsf_icon", "dsf_selected", "dsf_href", "data-test"];
const _hoisted_3 = ["dsf_id", "dsf_title", "dsf_icon", "dsf_selected", "dsf_href", "data-test"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavigationItems",
  props: {
    navigation: {},
    dataToWatch: {},
    translateItem: { type: Function },
    isItemSelected: { type: Function }
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const formatRoute = (item) => item.kind === "leaf" ? `${item.route}${item.params || ""}` : "";
    const navigationItems = shallowRef([]);
    watch(
      props.dataToWatch,
      () => {
        navigationItems.value = getVisibleMenuItems(props.navigation);
      },
      {
        deep: true,
        immediate: true
      }
    );
    const isNavItemSelected = (route2, item) => {
      if (props.isItemSelected) {
        return props.isItemSelected(route2, item);
      }
      return route2.path.startsWith(item.route);
    };
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(navigationItems.value, (item, idx) => {
        return openBlock(), createElementBlock(Fragment, null, [
          item.kind === "widget" ? (openBlock(), createBlock(resolveDynamicComponent(item.component), {
            key: `widget-${idx}`,
            "data-test": item.dataTest
          }, null, 8, ["data-test"])) : item.kind === "category" ? (openBlock(), createElementBlock("dsf-navbar-item", {
            key: `category-${idx}`,
            dsf_title: _ctx.translateItem(item),
            dsf_icon: item.icon,
            dsf_always_open: "",
            "data-test": item.dataTest
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.children, (child, childIdx) => {
              return openBlock(), createElementBlock("dsf-navbar-item", {
                key: `child-${childIdx}`,
                dsf_id: child.route,
                dsf_title: _ctx.translateItem(child),
                dsf_icon: child.icon,
                dsf_selected: unref(route).path.startsWith(child.route),
                dsf_href: formatRoute(child),
                "data-test": child.dataTest
              }, null, 8, _hoisted_2);
            }), 128))
          ], 8, _hoisted_1)) : item.kind === "leaf" ? (openBlock(), createElementBlock("dsf-navbar-item", {
            key: `leaf-${idx}`,
            dsf_id: item.route,
            dsf_title: _ctx.translateItem(item),
            dsf_icon: item.icon,
            dsf_selected: isNavItemSelected(unref(route), item),
            dsf_href: formatRoute(item),
            "data-test": item.dataTest
          }, null, 8, _hoisted_3)) : createCommentVNode("", true)
        ], 64);
      }), 256);
    };
  }
});
export {
  _sfc_main as default
};
